import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BlogService {
  baseUrl = environment.baseBlogUrl;
  constructor(private http: HttpClient) { }

  getgenre() {
    return this.http.get(`${this.baseUrl}/api/posts/?populate=*`);
  }
}